import React, { useState } from 'react';
import { FAQ as FAQType } from '../../types/landingPage';

interface FAQSectionProps {
  faqs: FAQType[];
  title?: string;
  subtitle?: string;
}

const FAQSection: React.FC<FAQSectionProps> = ({ faqs, title = "Najczęstsze pytania", subtitle }) => {
  const [openItem, setOpenItem] = useState<number | null>(null);

  // Filter active FAQs and sort by order
  const activeFaqs = faqs
    .filter(faq => faq.is_active)
    .sort((a, b) => a.order - b.order);

  const toggleItem = (id: number) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <section className="landing-faq">
      <div className="landing-container">
        <div className="landing-section-header">
          <h2>{title}</h2>
          <p>{subtitle || "Odpowiedzi na najczęściej zadawane pytania o trening personalny"}</p>
        </div>

        <div className="landing-faq-list">
          {activeFaqs.map((faq) => (
            <div
              key={faq.id}
              className={`landing-faq-item ${openItem === faq.id ? 'landing-faq-item-open' : ''}`}
            >
              <button
                className="landing-faq-question"
                onClick={() => toggleItem(faq.id)}
              >
                <span className="landing-faq-question-text">{faq.question}</span>
                <span className={`landing-faq-icon ${openItem === faq.id ? 'landing-faq-icon-open' : ''}`}>
                  +
                </span>
              </button>
              <div className={`landing-faq-answer ${openItem === faq.id ? 'landing-faq-answer-open' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;